export const selector = '.artwork-grid-page'

export default (
    el = null
) => {
    if (!el)
        return

    const grid = el
        .querySelector('#artwork-grid-list')

    if (!grid)
        return

    console.groupCollapsed('Artwork Grid Page')

    const btn = el
        .querySelector('.artwork-grid-page-btn')

    const items = Array.from(grid
        .querySelectorAll('li[aria-hidden="true"'))

    const loadMoreEvent = new CustomEvent('loadMoreEvent', {
        detail: {
            message: 'The page is updated with more items'
        },
        bubbles: true,
        cancelable: true
    })

    const bottomOffset = 1000

    const { artworkVisible, artworkTotal } = grid.dataset

    const autoScrollLimit = 50 // items

    const total = parseInt(artworkTotal)

    let visible = parseInt(artworkVisible)

    let moreToLoad = +artworkTotal > visible

    const loadMore = () => {
        moreToLoad = false
        const itemsUnhide = items
            .splice(0, 10)

        itemsUnhide
            .forEach(item => item
                .setAttribute('aria-hidden', 'false'))

        visible = parseInt(visible)
            + itemsUnhide.length

        moreToLoad = visible < total

        grid.setAttribute('data-artwork-visible',
            visible)

        grid.dispatchEvent(loadMoreEvent)

        if (total >= visible && !moreToLoad)
            btn.classList.add('d-none')
    }

    const scrollMore = () => {
        const bounds = grid.getBoundingClientRect()
        const { bottom } = bounds

        if (bottom < bottomOffset && moreToLoad
                && visible <= autoScrollLimit)
            loadMore()
    }

    document.addEventListener('scroll',
        scrollMore)

    if (btn)
        btn.addEventListener('click',
            loadMore)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                document.removeEventListener('scroll',
                    scrollMore)

                if (btn)
                    btn.removeEventListener('click',
                        loadMore)
            })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
